import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const selectorRequirementExpirationDate = (
  requirement: IRequirementResponse
) => {
  return requirement.expiresAt;
};
